export default __webpack_public_path__ + "static/media/happy-illustration.93e38344.svg";